import { render, staticRenderFns } from "./DemGeneratorInputsForm.vue?vue&type=template&id=b24eeed6"
import script from "./DemGeneratorInputsForm.vue?vue&type=script&lang=js"
export * from "./DemGeneratorInputsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports